import React, { useCallback } from 'react';
import { cn, formatCoordinateForCopy } from '@ais-ui/utils';
import { PiCopy } from 'react-icons/pi';
import { useMapContextMenu, CoordinateFeature } from './MapContextMenuContext';
import { useSettings } from '../../Settings/SettingsProvider';

interface CoordinateContextMenuItemsProps {
  coordinate: CoordinateFeature['data'];
}

interface MenuItemProps {
  disabled?: boolean;
  onClick: () => void;
  children: React.ReactNode;
}

const MenuItem = ({ disabled, onClick, children }: MenuItemProps) => (
  <div
    className={cn(
      'relative flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none',
      disabled
        ? 'pointer-events-none opacity-50'
        : 'hover:bg-accent hover:text-accent-foreground cursor-pointer',
    )}
    onClick={disabled ? undefined : onClick}
  >
    {children}
  </div>
);

export const CoordinateContextMenuItems = ({
  coordinate,
}: CoordinateContextMenuItemsProps) => {
  const { closeContextMenu } = useMapContextMenu();
  const { settings } = useSettings();

  const handleCopyCoordinates = useCallback(async () => {
    const format = settings['ribbonPlugin.settings']?.cursor_position_format;
    const formattedCoordinate = formatCoordinateForCopy(
      coordinate.longitude,
      coordinate.latitude,
      format,
    );

    if (formattedCoordinate) {
      await navigator.clipboard.writeText(formattedCoordinate);
    }

    closeContextMenu();
  }, [coordinate, settings, closeContextMenu]);

  return (
    <MenuItem onClick={handleCopyCoordinates}>
      <PiCopy className="h-4 w-4" />
      Copy Coordinate
    </MenuItem>
  );
};
